<ng-template #editModeTemplateRef>
    <div class="edit-account-row">
        <div class="column text-column">
            <div class="name-padding-left"></div>
            <ng-container *ngFor="let flisIndentation of flisLevelsIndentations">
                <div class="level-indentation"></div>
            </ng-container>
            <div></div>
            <div class="account-column level-border-bottom account-text-column text-overflow">
                <span class="account-number" *ngIf="!addNewAccountMode && !noAccountNumber">
                    {{ account.accountNumber }}
                </span>
                <span class="account-number-input" *ngIf="addNewAccountMode && !noAccountNumber">
                    <aum-input
                        [aumFormControl]="accountForm.controls['accountNumber']"
                        floatLabel="auto"
                        id="accountNumber"
                        [simpleInput]="true"
                        [placeholder]="localizationKeys.aumico_editable_account_placeholder_number | i18next"
                        [disabled]="account.type === AccountType.UNCOVERED_SHORTFALL || account.isBalanceSwitchAccount"
                    >
                    </aum-input>
                </span>
                <span *ngIf="!addNewAccountMode" class="text-overflow">
                    {{ account.name
                    }}{{ account.shareholder != null && account.shareholder !== '' ? ' - ' + account.shareholder : '' }}
                </span>
                <span *ngIf="addNewAccountMode" class="text-overflow account-name-input">
                    <aum-input
                        [aumFormControl]="accountForm.controls['name']"
                        floatLabel="auto"
                        id="name"
                        [simpleInput]="true"
                        [placeholder]="localizationKeys.aumico_editable_account_placeholder_name | i18next"
                        [disabled]="account.isBalanceSwitchAccount"
                    >
                    </aum-input>
                </span>
            </div>
        </div>
        <div class="account-column account-column-values">
            <div class="column value-column account-column level-border-bottom closing-column">
                <span class="closing-value-input">
                    <aumico-number-input
                        [control]="accountForm.controls['calculatedClosingBalance']"
                        [placeholder]="localizationKeys.aumico_editable_account_placeholder_closing_value | i18next"
                        [disabled]="account.type === AccountType.UNCOVERED_SHORTFALL"
                    >
                    </aumico-number-input>
                </span>
            </div>
            <div class="column value-column account-column level-border-bottom">
                <span
                    *ngIf="
                        hasPreviousData &&
                        (supportOperation ||
                            isPriorYearUnlockedForThisRow ||
                            !disableEditingPreviousYearValue)
                    "
                    class="closing-value-input"
                >
                    <aumico-number-input
                        [control]="accountForm.controls['calculatedOpeningBalance']"
                        [placeholder]="localizationKeys.aumico_editable_account_placeholder_opening_value | i18next"
                        [disabled]="account.type === AccountType.UNCOVERED_SHORTFALL"
                    >
                    </aumico-number-input>
                </span>
                <span
                    *ngIf="
                        hasPreviousData &&
                        disableEditingPreviousYearValue &&
                        !supportOperation &&
                        !isPriorYearUnlockedForThisRow
                    "
                    class="value-column-cell-value"
                    >{{ account.calculatedOpeningBalance ?? 0 | finNumber }}
                </span>
            </div>
            <div class="column value-column account-column level-border-bottom">
                <div class="account-opening-column-cell-value">
                    <div>
                        <span
                            *ngIf="
                                hasPreviousData &&
                                disableEditingPreviousYearValue &&
                                !supportOperation &&
                                !isPriorYearUnlockedForThisRow
                            "
                            class="ham-icon unlock-prior-year-button"
                            (click)="onUnlockPriorYear()"
                            [hamTooltip]="localizationKeys.aumico_editable_account_unlock_prior_year_tooltip | i18next"
                        >
                            <i class="lock-icon"></i>
                        </span>
                        <mat-icon
                            class="save-account-button"
                            svgIcon="inline-save"
                            (click)="onSaveAccount()"
                        ></mat-icon>
                        <mat-icon
                            class="close-edit-account-button"
                            svgIcon="close"
                            (click)="onCancelEditAccount()"
                        ></mat-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-container *ngIf="!isEditing; else editModeTemplateRef">
    <div
        class="row-level"
        [attr.data-testid]="'account-' + account.accountNumber"
        [ngClass]="{
            'special-account':
                account.type === AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING &&
                isAutomaticTransferOfAnnualResultEnabled
        }"
    >
        <div class="column text-column">
            <div class="name-padding-left"></div>
            <ng-container *ngFor="let flisIndentation of flisLevelsIndentations">
                <div class="level-indentation"></div>
            </ng-container>
            <div></div>
            <div
                class="account-column level-border-bottom account-text-column text-overflow"
                [ngClass]="{
                    'special-account':
                        account.type === AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING &&
                        isAutomaticTransferOfAnnualResultEnabled
                }"
            >
                <!-- Drag icon removed - sorting should be done in Grouping & Masking tab -->
                <span *ngIf="account.type !== AccountType.UNCOVERED_SHORTFALL" class="account-number">
                    {{ account.accountNumber }}
                </span>
                <span
                    class="text-overflow with-badge"
                    [ngClass]="{ 'account-name-padding': account.type === AccountType.UNCOVERED_SHORTFALL }"
                    ellipsis
                >
                    {{ account.name
                    }}{{ account.shareholder != null && account.shareholder !== '' ? ' - ' + account.shareholder : '' }}
                </span>

                <span>
                    <span
                        *ngIf="account.isSummarized === true"
                        hamIconShapes
                        icon="assets/hamIcons/split.svg"
                        [size]="'20px'"
                        [variant]="'transparent'"
                        style="margin-right: 8px; cursor: pointer"
                        [hamTooltip]="'aumico_templates_summarized_accounts_mapped_tooltip' | i18next"
                        [withArrow]="true"
                        [backGroundHexColor]="'#1F2A37'"
                        (click)="removeAccountFrom($event)"
                    ></span>
                </span>
            </div>
            <div
                *ngIf="
                    account.type == AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING &&
                    isAutomaticTransferOfAnnualResultEnabled
                "
                class="account-column account-text-column text-overflow special-account"
            >
                <span class="badge" [class.--purple]="true">
                    <span class="ham-icon icon">
                        <i class="arrow-right-arrow-left-icon"></i>
                    </span>
                    <span>
                        {{ 'aumico_templates_annual_profit_account_badge_text' | i18next }}
                    </span>
                </span>
            </div>
        </div>
        <div
            class="account-column account-column-values"
            [ngClass]="{
                'special-account':
                    account.type === AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING &&
                    isAutomaticTransferOfAnnualResultEnabled
            }"
        >
            <div
                class="column value-column account-column level-border-bottom closing-column"
                [ngClass]="{
                    'special-account':
                        account.type === AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING &&
                        isAutomaticTransferOfAnnualResultEnabled
                }"
            >
                <span class="value-column-cell-value" data-testid="cell-closing">{{ account.calculatedClosingBalance | finNumber }}</span>
            </div>
            <div
                class="column value-column account-column level-border-bottom"
                [ngClass]="{
                    'special-account':
                        account.type === AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING &&
                        isAutomaticTransferOfAnnualResultEnabled
                }"
            >
                <div class="account-opening-column-cell-value">
                    <span
                        *ngIf="
                            errorInPreviousAnnualProfit &&
                            account.type === AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING &&
                            isAutomaticTransferOfAnnualResultEnabled
                        "
                        class="ham-icon"
                    >
                        <i class="exclamation-outline-icon"></i>
                    </span>
                    <span
                        *ngIf="
                            account.type !== AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING ||
                            !errorInPreviousAnnualProfit
                        "
                        class="value-column-cell-value"
                        data-testid="cell-opening"
                        >{{ account.calculatedOpeningBalance | finNumber }}</span
                    >
                </div>
            </div>
            <div
                class="column value-column account-column level-border-bottom"
                [ngClass]="{
                    'special-account':
                        account.type === AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING &&
                        isAutomaticTransferOfAnnualResultEnabled
                }"
            >
                <div class="account-opening-column-cell-value menu-div">
                    <span
                        class="ham-icon switch-account-icon"
                        [hamTooltip]="'aumico_templates_switch_accounts_tooltip_1' | i18next"
                        (click)="splitAccountClicked()"
                        style="color: #00c9d4"
                        icon="assets/icons/aumico-pattern-icon-balance-switch6.svg"
                        *ngIf="
                            (account.calculatedClosingBalance < 0 || account.calculatedOpeningBalance < 0) &&
                            account.type !== AccountType.INCOME &&
                            account.type !== AccountType.UNCOVERED_SHORTFALL &&
                            account.type !== AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING
                        "
                    >
                        <i class="balance-switch-icon"></i>
                    </span>

                    <span
                        [hamTooltip]="'aumico_templates_switch_accounts_tooltip_2' | i18next"
                        class="ham-icon split-account-icon"
                        style="color: #ccc"
                        icon="assets/icons/aumico-pattern-icon-balance-switch6.svg"
                        *ngIf="account.isBalanceSwitchAccount === true"
                    >
                        <i class="balance-switch-icon"></i>
                    </span>

                    <span
                        *ngIf="
                            account.type !== AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING ||
                            (account.type === AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING &&
                                !isAutomaticTransferOfAnnualResultEnabled)
                        "
                        class="aumico-pattern-icon-remove"
                        (click)="removeAccountFrom($event)"
                        title="remove account"
                    >
                        <i></i>
                    </span>
                    <menu-list-for-mapping
                        [item]="account"
                        [isBalanceSwitchAccountDisabled]="
                            !account.isBalanceSwitchAccount &&
                            account.type !== AccountType.INCOME &&
                            account.type !== AccountType.UNCOVERED_SHORTFALL &&
                            account.type !== AccountType.SPECIAL_ACCOUNT_DELETE_ON_MAPPING
                        "
                        [isAutomaticTransferOfAnnualResultEnabled]="isAutomaticTransferOfAnnualResultEnabled"
                        [disableEditingAnnualProfitValue]="!hasPreviousData"
                        [businessModel]="businessModel"
                        [parentType]="parentType"
                        [supportOperation]="supportOperation"
                        (onClickEmitter)="onMenuActionClickedHandler($event)"
                    ></menu-list-for-mapping>
                </div>
            </div>
        </div>
    </div>
</ng-container>
